module.exports = __webpack_public_path__ + "static/img/miner-mk-2_256.01589c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/miner-mk-2_256.png
// module id = f1Cq
// module chunks = 0